/**
 * text가 빈칸("") 또는 null 인지 여부
 */
function isEmpty(text = '') {
  if (text === '') return true;
  if (text === null) return true;
  if (JSON.stringify(text) === '{}') return true;
  if (JSON.stringify(text) === '[]') return true;
  
  return false;
}

export default isEmpty;
